module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAAA2CAYAAABkxd/2AAAAAXNSR0IArs4c6QAAAR5JREFUaAXt2TEKwjAUxvHWKzgIrt7EA9QDuFRcPJPgITyPuOsgItq5fg9cREoaSINJ/w8yaNL38n6FLq9o27bWumvlEtZLXQSK0lQC5fqrNKUixIUmIZLknAMgx9sFqAfQRmcejnMpbVsv1hOBAAIIIIAAAggggAACCCCAAAIIIIAAAghEFrCxz0o1D1rTyLVjl7up4FbToKNPYQO66IGZz0MJn33q7nMhvfr2kO3gsAvAd6DI2KdL8vO/ATWOMzlte/dqQGst+4DlHtaj9UoggAACCCCAAAIIIIAAAggggAACCCCAAAIDCdhUY6nce63FQDVSTXvSxXdjm4v5vqzr6OZivkLMxRxiY5uLOTh+thsDqrTsg0R8C5z1s3oDqGoDcZrO4FYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/app/images/icons/menu@3x.png
// module id = 548
// module chunks = 0